/* eslint-disable */
import React, { Component, Fragment } from "react";
import { translate } from "react-i18next";
import onClickOutside from "react-onclickoutside";
import { Link, Route } from "react-router-dom";
import {
  animateScroll,
  scroller,
  Element as ScrollElement,
} from "react-scroll";
// import YouTube from 'react-youtube';
// import ReactPlayer from 'react-player'
import A from "../../components/A";
import WistiaPlayerPL from "../../components/WistiaPlayerPL";
import WistiaPlayerEN from "../../components/WistiaPlayerEN";
// import ContactWidget from '../containers/ContactWidget'
import LocatedMenu from "../../containers/LocatedMenu";
import VCSingleImage from "../../containers/VCSingleImage";
import "animate.css/animate.min.css";
const isMobile = function () {
  return window.innerWidth <= 992;
};

const isDesktop = function () {
  return window.innerWidth > 992;
};

// Language menu - for activate uncoment LangMenu & LangMenuContainer lines (22-43 and 351-355)
class LangMenu extends Component {
  handleClickOutside = (e) => {
    this.props.handleToggle();
  };
  render() {
    return (
      <div className="select">
        <span onClick={this.props.handleToggle}>
          {this.props.t("currentLng")}
        </span>

        <div
          className={`select-options${this.props.toggle ? " " + "show" : " "}`}
        >
          <ul>
            <li>
              <Link to="/pl" onClick={this.handleClickOutside}>
                PL
              </Link>
            </li>
            <li>
              <Link to="/en" onClick={this.handleClickOutside}>
                EN
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const LangMenuContainer = translate()(onClickOutside(LangMenu));

class TopMenuColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullWidthStyle: null,
      mouseIn: false,
      toggle: false,
    };
    this.containerNode = React.createRef();
  }
  handleClickOutside = (e) => {
    this.props.handleToggle(e);
  };
  handleItemClick = (e) => {
    if (isMobile() && e.target.tagName !== "A") {
      this.props.handleToggle(e);
    }
    if (isMobile() && e.target.tagName === "A") {
      this.props.handleToggleMainMenu(e);
    }
    if (isDesktop() /*&& e.target.tagName !== 'A'*/) {
      this.setState({
        fullWidthStyle: null,
        mouseIn: false,
      });
      this.props.updateMouseIn(false);
    }
  };
  handleSubitemClick = (e) => {
    if (isMobile()) {
      this.props.handleToggle(e);
      this.props.handleToggleMainMenu(e);
    }
    if (isDesktop()) {
      this.setState({
        fullWidthStyle: null,
        mouseIn: false,
      });
      this.props.updateMouseIn(false);
    }
  };
  handleMouseEnter = (e) => {
    if (isDesktop()) {
      this.setState({
        mouseIn: true,
      });
      this.props.updateMouseIn(true);
      this.props.updateFixedMenu(true);
    }
  };
  handleMouseLeave = (e) => {
    if (isDesktop()) {
      this.setState({
        fullWidthStyle: null,
        mouseIn: false,
      });
      this.props.updateMouseIn(false);
      this.props.updateFixedMenu(false);
    }
  };
  handleMouseOver = (e) => {
    if (isDesktop() && this.state.fullWidthStyle === null) {
      const { clientHeight } = this.containerNode.current;
      this.setState({
        fullWidthStyle: {
          marginBottom: clientHeight + 5 + "px",
        },
      });
    }
  };
  render() {
    return (
      <li
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onMouseOver={this.handleMouseOver}
        style={this.state.fullWidthStyle}
        className={`${
          this.state.mouseIn || this.props.toggle ? "hover" : ""
        } main-element`}
      >
        <span onClick={this.handleItemClick}>
          <A
            scrollToTopOnClick
            href={this.props.items[0].url}
            target={this.props.target}
          >
            {this.props.items[0].name}
          </A>
        </span>
        <ul ref={this.containerNode}>
          {this.props.items.slice(1).map((item, key) => (
            <li key={key}>
              <A
                scrollToTopOnClick
                href={item.url}
                onClick={this.handleSubitemClick}
              >
                {item.name}
              </A>
            </li>
          ))}
        </ul>
      </li>
    );
  }
}

const TopMenuColumnContainer = onClickOutside(TopMenuColumn);

class CustomTopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: {},
    };
  }
  render() {
    return (
      <Fragment>
        <ul>
          {this.props.items
            .filter((item) => item.getParent() === 0)
            .map((item, key) => (
              <TopMenuColumnContainer
                key={key}
                target={key === 5 ? "_blank" : null}
                disableOnClickOutside={!this.state.toggle[key]}
                handleToggle={(e) =>
                  this.setState({
                    toggle: {
                      ...this.state.toggle,
                      [key]: !this.state.toggle[key],
                    },
                  })
                }
                handleToggleMainMenu={this.props.parentProps.toggleMainMenu}
                updateFixedMenu={this.props.parentProps.updateFixedMenu}
                updateMouseIn={this.props.parentProps.updateMouseIn}
                toggle={this.state.toggle[key]}
                items={[{ name: item.getTitle(), url: item.getUrl() }].concat(
                  this.props.items
                    .filter((subitem) => subitem.getParent() === item.getId())
                    .map((subitem) => ({
                      name: subitem.getTitle(),
                      url: subitem.getUrl(),
                    }))
                )}
              />
            ))}
        </ul>
        <div className="mobile-only">
          <A href={this.props.items[this.props.items.length - 1].getUrl()}>
            {this.props.items[this.props.items.length - 1].getTitle()}
          </A>
          {/* <span>PL</span> */}
          <div className="select">
            <div className="select-options">
              <ul>
                <li>
                  <Link
                    onClick={this.handleToggleMainMenu}
                    to="/pl"
                    className={
                      this.props.i18n.language === "pl" ? "current" : null
                    }
                  >
                    PL
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={this.handleToggleMainMenu}
                    to="/en"
                    className={
                      this.props.i18n.language === "en" ? "current" : null
                    }
                  >
                    EN
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const CustomTopMenuContainer = translate()(CustomTopMenu);

class BottomMenuColumn extends Component {
  handleClickOutside = (e) => {
    this.props.handleToggle();
  };
  handleItemClick = (e) => {
    if (isMobile() && e.target.tagName !== "A") {
      this.props.handleToggle(e);
    }
  };
  render() {
    return (
      <div className="footer-colums__column">
        <h5
          className={this.props.toggle ? "active" : undefined}
          onClick={this.handleItemClick}
        >
          <A href={this.props.items[0].url}>{this.props.items[0].name}</A>
        </h5>
        <ul>
          {this.props.items.slice(1).map((item, key) => (
            <li key={key}>
              <A
                scrollToTopOnClick
                href={item.url}
                onClick={this.props.handleToggle}
              >
                {item.name}
              </A>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const BottomMenuColumnContainer = onClickOutside(BottomMenuColumn);

class CustomBottomMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: {},
    };
  }
  render() {
    return this.props.items
      .filter((item) => item.getParent() === 0)
      .map((item, key) => (
        <BottomMenuColumnContainer
          key={key}
          disableOnClickOutside={!this.state.toggle[key]}
          handleToggle={(e) =>
            this.setState({
              toggle: { ...this.state.toggle, [key]: !this.state.toggle[key] },
            })
          }
          toggle={this.state.toggle[key]}
          items={[{ name: item.getTitle(), url: item.getUrl() }].concat(
            this.props.items
              .filter((subitem) => subitem.getParent() === item.getId())
              .map((subitem) => ({
                name: subitem.getTitle(),
                url: subitem.getUrl(),
              }))
          )}
        />
      ));
  }
}

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fixedMenu: false,
      mouseIn: false,
      showScrollToTop: false,
      showVideo: false,
      currentPage: "",
      scrollToTop: false,
      // isMobile: false,
      // toggleFooter1: false,
      // toggleFooter2: false,
      // toggleFooter3: false,
      // toggleFooter4: false,
      // toggleFooter5: false,
      toggleContactWidgetClassName: "",
      toggleLangMenu: false,
      toggleMainMenu: false,
    };

    this.plugins = {
      "postRoll-v1": {
        text: "",
        link: "https://wistia.com",
      },
    };

    this.plugins2 = {
      "postRoll-v1": {
        text: "",
        link: "https://wistia.com",
      },
    };
  }

  toggleOpenContactWidget = (e) => {
    // console.log('toggle widget')
    let toggleContactWidgetClassName = "";
    switch (this.state.toggleContactWidgetClassName) {
      case "":
        toggleContactWidgetClassName = " active";
        break;
      case " active":
        toggleContactWidgetClassName = "";
        break;
      case " thiner":
        toggleContactWidgetClassName = " active";
        break;
      default:
    }
    this.setState({ toggleContactWidgetClassName });
  };
  toggleThinerContactWidget = (e) => {
    // console.log('toggle thiner')
    let toggleContactWidgetClassName = "";
    switch (this.state.toggleContactWidgetClassName) {
      case "":
        toggleContactWidgetClassName = " thiner";
        break;
      case " thiner":
        toggleContactWidgetClassName = " ";
        break;
      case " active":
        toggleContactWidgetClassName = " thiner";
        break;
      default:
    }
    this.setState({ toggleContactWidgetClassName });
  };
  toggleLangMenu = (e) => {
    this.setState({ toggleLangMenu: !this.state.toggleLangMenu });
  };
  toggleMainMenu = (e) => {
    this.setState({ toggleMainMenu: !this.state.toggleMainMenu });
  };
  // toggleFooter1 = e => {
  //   this.setState({ toggleFooter1: !this.state.toggleFooter1 })
  // }
  // toggleFooter2 = e => {
  //   this.setState({ toggleFooter2: !this.state.toggleFooter2 })
  // }
  // toggleFooter3 = e => {
  //   this.setState({ toggleFooter3: !this.state.toggleFooter3 })
  // }
  // toggleFooter4 = e => {
  //   this.setState({ toggleFooter4: !this.state.toggleFooter4 })
  // }
  // toggleFooter5 = e => {
  //   this.setState({ toggleFooter5: !this.state.toggleFooter5 })
  // }
  scroll = () => {
    // https://stackoverflow.com/questions/29725828/update-style-of-a-component-onscroll-in-react-js
    let supportPageOffset = window.pageXOffset !== undefined;
    let isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    let scroll = {
      x: supportPageOffset
        ? window.pageXOffset
        : isCSS1Compat
        ? document.documentElement.scrollLeft
        : document.body.scrollLeft,
      y: supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop,
    };
    return scroll;
  };
  handleScroll = () => {
    if (this.scroll().y > 0) {
      if (this.state.fixedMenu === false) {
        this.setState({ fixedMenu: true });
      }
    } else {
      if (this.state.fixedMenu === true && this.state.mouseIn === false) {
        this.setState({ fixedMenu: false });
      }
    }
    if (this.scroll().y > 1000) {
      if (this.state.showScrollToTop === false) {
        this.setState({ showScrollToTop: true });
      }
    } else {
      if (this.state.showScrollToTop === true) {
        this.setState({ showScrollToTop: false });
      }
    }
    if (this.scroll().y > 500) {
      if (this.state.scrollToTop === false) {
        this.setState({ scrollToTop: true });
      }
    } else {
      if (this.state.scrollToTop === true) {
        this.setState({ scrollToTop: false });
      }
    }
  };
  // handleResize = () => {
  //   const isMobile = window.innerWidth < 577
  //   this.setState({ isMobile })
  // }
  updateFixedMenu = (value) => {
    if (this.scroll().y === 0) this.setState({ fixedMenu: value });
  };
  updateMouseIn = (value) => {
    this.setState({
      mouseIn: value,
    });
  };
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    // this.handleResize()
    // window.addEventListener('resize', this.handleResize)
  }
  componentDidUpdate(prevProps) {
    if (
      this.state.scrollToTop === true &&
      prevProps.title != this.props.title
    ) {
      window.scrollTo(0, 0);
      this.setState({ scrollToTop: false });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    // window.removeEventListener('resize', this.handleResize)
  }
  isPLlang = () => {
    if (window.location.pathname.indexOf("pl") > 0) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    return (
      <Fragment>
        <header id="top">
          <div
            className={`main-menu${
              this.state.fixedMenu || !this.props.mediaId ? " fixed" : ""
            }`}
          >
            <div className="container">
              <Link to={`/${this.props.i18n.language}`} className="brand">
                <img src="/img/gi-logo.svg" alt="Gi Group logo" />
              </Link>
              <button
                className={`hamburger hamburger--elastic${
                  this.state.toggleMainMenu ? " " + "is-active" : ""
                }`}
                type="button"
                aria-label="Menu"
                aria-controls="navigation"
                aria-expanded="true/false"
                onClick={this.toggleMainMenu}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <div
                id="navigation"
                className={`navbar-collapse collapse${
                  this.state.toggleMainMenu && isMobile() ? " " + "in" : ""
                }`}
              >
                <LangMenuContainer
                  disableOnClickOutside={!this.state.toggleLangMenu}
                  handleToggle={this.toggleLangMenu}
                  toggle={this.state.toggleLangMenu}
                />
                <LocatedMenu
                  location="topMenuLocation"
                  customMenu={CustomTopMenuContainer}
                  updateFixedMenu={this.updateFixedMenu}
                  updateMouseIn={this.updateMouseIn}
                  toggleMainMenu={this.toggleMainMenu}
                />
              </div>
            </div>
          </div>
        </header>
        <div
          className={`main-content${
            this.props.contentClassName ? " " + this.props.contentClassName : ""
          }`}
        >
          {/* {isMobile ? */}

          {/* <Route
            exact
            path="/:lng(pl|en)"
            render={() => (
              <div className="animation mobile-only">
                <Flexifit aspectRatio={2.17} >
                <div className="video-background">
                  <div className="video-foreground">
                    <YouTube
                        videoId={this.props.t('custom:home.ytMobile')}
                        opts={{
                          playerVars: { // https://developers.google.com/youtube/player_parameters
                            autoplay: 1,
                            controls: 0,
                            rel: 0,
                            showinfo: 0
                          }
                        }}
                        className="video-iframe"
                        onReady={event => event.target.playVideo()}
                        onEnd={event => event.target.playVideo()}
                      />
                    {this.isPLlang() ? (
                      <WistiaPlayerPL
                        hashedId="f0ez06385l"
                        playerColor="#00b2c6"
                        plugin={this.plugins}
                      />
                    ) : (
                      <WistiaPlayerEN
                        hashedId="4b5kcpvxry"
                        playerColor="#00b2c6"
                        plugin={this.plugins}
                      />
                    )}
                  </div>
                </div>
                </Flexifit>
              </div>
            )}
          /> */}

          {/* : */}

          <Route
            exact
            path="/:lng(pl|en)"
            render={() => (
              <div className="animation hidden-sm">
                {/* {this.isPLlang() ?
                    <WistiaPlayerPL hashedId="4b5kcpvxry" playerColor="#00b2c6" plugin={this.plugins}/>
                    :
                    <WistiaPlayerEN hashedId="f0ez06385l" playerColor="#00b2c6" plugin={this.plugins} />
              }    */}
                {/* <Flexifit aspectRatio={2.17} > */}
                {/* <iframe frameBorder="0" allowFullScreen="1" allow="autoplay; loop; playlist; encrypted-media" title="YouTube video player" width="100%" height="100%" src={`https://www.youtube.com/embed/${this.props.t('custom:home.ytDesktop')}?version=3&amp;autoplay=1&amp;controls=0&amp;loop=1&amp;playlist=${this.props.t('custom:home.ytDesktop')}`}></iframe> */}
                <div
                  className={this.state.videoBackgroundClass}
                  id="video-overlay"
                  style={{ backgroundImage: "url(img/videoBackground.png)" }}
                />

                {/* </Flexifit> */}
              </div>
            )}
          />

          {/* } */}

          <Route
            exact
            path="/:lng(pl|en)"
            render={() => (
              <div className="container">
                <div className="arrow bounce">
                  <a
                    className="arrow-down"
                    onClick={() =>
                      scroller.scrollTo("contentBegining", { smooth: true })
                    }
                  >
                    <span>[{this.props.t("custom:scrollDown")}]</span>
                    <strong></strong>
                  </a>
                </div>
              </div>
            )}
          />

          {this.props.mediaId ? (
            <VCSingleImage
              className="image-bg"
              size="full"
              mediaId={this.props.mediaId}
            />
          ) : null}

          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <h1>{this.props.title}</h1>
                {this.props.subtitle ? <h3>{this.props.subtitle}</h3> : null}
              </div>
            </div>
          </div>
        </div>

        <ScrollElement name="contentBegining" />

        <div id="content">
          <div
            className={`container${
              this.props.contentClassName
                ? " " + this.props.contentClassName
                : ""
            }`}
            ref={this.props.containerNode}
          >
            {this.props.children}
          </div>
        </div>
        <footer id="footer">
          <div className="container">
            <div className="footer-colums">
              <LocatedMenu
                location="bottomMenuLocation"
                customMenu={CustomBottomMenu}
              />
              {/* <hr />
                <BottomMenuColumnContainer
                  disableOnClickOutside={!this.state.toggleFooter1}
                  handleToggle={this.toggleFooter1}
                  toggle={this.state.toggleFooter1}
                  items={[
                    { name: 'O nas', url: '/o-nas/' },
                    { name: 'Grupa Gi Group Poland', url: '/o-nas/grupa-work-service/' },
                    { name: 'Historia', url: '#' },
                    { name: 'Odpowiedzialność społeczna', url: '/o-nas/odpowiedzialnosc-spoleczna/' },
                    { name: 'Fundacja Gi Group Poland', url: '/o-nas/fundacja-work-service/' },
                    { name: 'Kariera', url: '/o-nas/kariera-w-work-service/' }
                  ]}
                />
                <BottomMenuColumnContainer
                  disableOnClickOutside={!this.state.toggleFooter2}
                  handleToggle={this.toggleFooter2}
                  toggle={this.state.toggleFooter2}
                  items={[
                    { name: 'Usługi', url: '/uslugi/' },
                    { name: 'Praca tymczasowa', url: '/uslugi/praca-tymczasowa/' },
                    { name: 'Outsourcing', url: '/uslugi/outsourcing/' },
                    { name: 'Dobór personalny', url: '/uslugi/dobor-personalny/' },
                    { name: 'Doradztwo HR', url: '/uslugi/doradztwo-hr/' },
                    { name: 'Transgraniczna wymiana pracowników', url: '/uslugi/transgraniczna-wymiana-pracownikow/' }
                  ]}
                />
                <BottomMenuColumnContainer
                  disableOnClickOutside={!this.state.toggleFooter3}
                  handleToggle={this.toggleFooter3}
                  toggle={this.state.toggleFooter3}
                  items={[
                    { name: 'Centrum prasowe', url: '/centrum-prasowe/' },
                    { name: 'Raporty', url: '/centrum-prasowe/raporty-2/' },
                    { name: 'Informacje prasowe', url: '/centrum-prasowe/informacje-prasowe/' },
                    { name: 'Aktualności', url: '' },
                    { name: 'Materiały do pobrania', url: '/centrum-prasowe/materialy-do-pobrania/' },
                    { name: 'Kalendarium', url: '/centrum-prasowe/kalendarium/' }
                  ]}
                />
                <BottomMenuColumnContainer
                  disableOnClickOutside={!this.state.toggleFooter4}
                  handleToggle={this.toggleFooter4}
                  toggle={this.state.toggleFooter4}
                  items={[
                    { name: 'Relacje inwestorskie', url: '/relacje-inwestorskie/' },
                    { name: 'Władze spółki', url: '/relacje-inwestorskie/wladze-spolki/' },
                    { name: 'Akcjonariat', url: '/relacje-inwestorskie/akcjonariat/' },
                    { name: 'Raporty', url: '/relacje-inwestorskie/raporty/' },
                    { name: 'Prezentacje', url: '/relacje-inwestorskie/prezentacje/' }
                  ]}
                />
                <BottomMenuColumnContainer
                  disableOnClickOutside={!this.state.toggleFooter5}
                  handleToggle={this.toggleFooter5}
                  toggle={this.state.toggleFooter5}
                  items={[
                    { name: 'Kontakt', url: '#' },
                    { name: 'Dla Kandydatów', url: '#' },
                    { name: 'Dla Pracodawców', url: '#' },
                    { name: 'Dla Inwestorów', url: '#' },
                    { name: 'Dla Mediów', url: '#' }
                  ]}
                /> */}
            </div>
            <div className="footer-bottom">
              <ul>
                <li>
                  <A href={this.props.t("custom:home.siteMapHref")}>
                    {this.props.t("custom:home.siteMapTitle")}
                  </A>
                </li>
                <li>
                  <A href={this.props.t("custom:home.agreementPolicyAHref")}>
                    {this.props.t("custom:home.policyTitle")}
                  </A>
                </li>
              </ul>
              {/* <ul className="social">
                <li>
                  <a
                    href="https://twitter.com/workservicepl"
                    className="twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/work-service-s-a-/?originalSubdomain=pl"
                    className="linkedin"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                  </a>
                </li>
              </ul> */}
            </div>
          </div>
        </footer>
        {this.state.showScrollToTop ? (
          <div className="go-top">
            <a
              className="arrow-up"
              onClick={() => animateScroll.scrollToTop({ smooth: true })}
            >
              <strong></strong>
              <span>{this.props.t("custom:scrollUp")}</span>
            </a>
          </div>
        ) : null}
        {/* <ContactWidget
          disableOnClickOutside={this.state.toggleContactWidgetClassName === '' || this.state.toggleContactWidgetClassName === ' thiner'}
          handleOpenToggle={this.toggleOpenContactWidget}
          handleThinerToggle={this.toggleThinerContactWidget}
          toggleClassName={this.state.toggleContactWidgetClassName}
        /> */}
      </Fragment>
    );
  }
}

const LayoutContainer = translate()(Layout);

class LayoutWrapper extends Component {
  render() {
    if (this.props.homeWrapper)
      return (
        <div className="home-wrapper">
          <LayoutContainer {...this.props} />
        </div>
      );

    return <LayoutContainer {...this.props} />;
  }
}

export default LayoutWrapper;



// WEBPACK FOOTER //
// ./src/custom/components/Layout.js